import { RecordSignature } from "@/api/record";
import { SignatureSelection } from "./SignatureSelection";
import { useModal } from "@/hooks";
import { useRevalidate } from "@/queries/certificate.queries";
import { UserSignature } from "@/api/user";
import { useSignSignature } from "@/queries/record.queries";

export type SignatureEntryProps = {
  type?: "Record" | "Revalidation";
  signature: RecordSignature;
};

export function SignatureEntry(props: SignatureEntryProps) {
  const sign = useSignSignature(props.signature);
  const revalidate = useRevalidate(props.signature);
  const modal = useModal();

  function handleSignSignature(signature?: UserSignature) {
    if (props.type === "Record") {
      sign.mutate(signature);
    } else {
      revalidate.mutate(signature);
    }
  }

  return (
    <div className="form-check">
      <input
        id="signature"
        type="checkbox"
        className="form-check-input"
        checked={props.signature.signed}
        disabled={props.signature.signed}
        onChange={() =>
          modal.show(<SignatureSelection {...props} onAccept={(signature) => handleSignSignature(signature)} />)
        }
      />
      <label htmlFor="signature" className="form-check-label fw-normal">
        {props.signature.title || "Signature"}
      </label>
    </div>
  );
}
